<template>
  <div>
    <div v-if="showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Zones</h1>
          <div class="pull-right">
            <div class="btn-group">
              <button
                class="pointer btn btn-lg btn-primary"
                v-on:click="form.showEdit({})"
              >
                Create New
              </button>
              <button
                class="pointer btn btn-lg btn-primary"
                v-on:click="getShape()"
                title="Upload zone shape file"
              >
                <i class="fa fa-map"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-heading">
          <h3 class="panel-title">All</h3>
        </div>
        <div class="panel-body">
          <div class="col-xs-12 table-responsive">
            <table
              class="table table-striped table-bordered table-hover table-fixed"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Coordinates</th>
                  <th>Contracts</th>
                  <th>Spray Zone</th>
                  <th width="120"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in form.list">
                  <td>{{ item.attributes.name }}</td>
                  <td
                    class="pointer"
                    v-on:click="showMap(item.attributes.coordinates)"
                  >
                    <i class="fa fa-map"></i>
                    {{ item.attributes.coordinates.length }} points
                  </td>
                  <td class="text-center">
                    <span v-if="item.attributes.contracts.length">{{
                      item.attributes.contracts.length
                    }}</span>
                  </td>
                  <td>{{ item.attributes.isSprayZone ? 'Yes' : 'No' }}</td>
                  <td>
                    <a
                      class="pointer text-primary"
                      v-on:click="form.showEdit({ id: item.id })"
                      ><i class="fa fa-pencil" style="margin-right: 10px;"></i
                    ></a>
                    <a
                      class="pointer text-danger"
                      v-on:click="form.destroy(item.id)"
                      ><i class="fa fa-times"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Associate zones</h1>
          <div class="pull-right">
            <div class="btn-group">
              <button
                class="pointer btn btn-lg"
                v-on:click="showList = !showList"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="bulk-change-container">
        <div class="bulk-change-options">
          <div class="title">Bulk Change Imported Zones</div>
          <!-- <div> Commented out, until it is ready to be added.
          <div class="bulk-label">Add to Zone Group</div>
          <select v-model="addToZoneGroup">
            <option value="">None</option>
            <option v-for="(zone, i) in form.list" :key="i">
              {{ zone.attributes.name }}
            </option>
          </select>
        </div> -->
          <div>
            <div class="bulk-label">Contract</div>
            <div class="form-group">
              <multiselect
                v-model="contractsToAdd"
                :options="contractsForAdding"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :hide-selected="true"
                track-by="name"
                placeholder=""
                :custom-label="customLabel"
              >
              </multiselect>
            </div>
          </div>
          <div>
            <input type="checkbox" v-model="isSprayZone" />
            <span class="bulk-checkbox-label">This is a Spray Zone</span>
          </div>
          <div>
            <button
              class="update-selected-entries-button"
              @click="UpdateSelectedShapeFiles"
            >
              Update Selected Entries Below
            </button>
          </div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <table class="table table-striped">
            <thead>
              <th>
                <input
                  class="header-checkbox"
                  type="checkbox"
                  :checked="allShapesSelected"
                  @change="toggleSelectAll()"
                />
                <label> Select All </label>
              </th>
              <th>Name</th>
              <th>County</th>
              <th>FIPSSTCO</th>
              <th>ID</th>
              <th>State</th>
              <th>Zone</th>
              <th>Points</th>
              <th>Contract</th>
              <th>Zone</th>
              <th>Spray Zone</th>
            </thead>
            <tbody>
              <tr v-for="(zone, index) in shapeFile" :key="index">
                <td>
                  <input
                    class="list-checkbox"
                    type="checkbox"
                    v-model="zone.selected"
                  />
                </td>
                <td>{{ zone.properties.Name }}</td>
                <td>{{ zone.properties.COUNTY }}</td>
                <td>{{ zone.properties.FIPSSTCO }}</td>
                <td>{{ zone.properties.ID }}</td>
                <td>{{ zone.properties.STATE }}</td>
                <td>{{ zone.properties.Zone }}</td>
                <td
                  class="pointer"
                  v-on:click="showMap(mapPoints(zone.geometry.coordinates[0]))"
                >
                  <i class="fa fa-map"></i>
                  {{ zone.geometry.coordinates[0].length }} points
                </td>
                <td>
                  {{
                    zone.properties.contracts.length
                      ? zone.properties.contracts
                          .map(({ name }) => name)
                          .join(', ')
                      : 'N/A'
                  }}
                </td>
                <td>
                  <select
                    class="form-control"
                    v-model="zoneAssociations[index]['id']"
                  >
                    <option value="ignore">Ignore</option>
                    <option value="new">Create New</option>
                    <option v-for="item in form.list" v-bind:value="item.id">{{
                      item.attributes.name
                    }}</option>
                  </select>
                  <input
                    type="text"
                    placeholder="name"
                    class="form-control"
                    v-model="zoneAssociations[index]['name']"
                  />
                </td>
                <td>{{ zone.properties.isSprayZone ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="11">
                  <button
                    class="btn btn-primary pull-right"
                    type="button"
                    v-on:click="createZones"
                  >
                    <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i>
                    <span v-if="!loading">Save and Add to Zone Table</span>
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="edit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ form.modal.title }}</h4>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="form.onSubmit({ updateStore: true })"
              @keydown="form.errors.clear($event.target.id)"
            >
              <input type="hidden" name="id" v-model="form.id" />

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('name') }"
              >
                <label class="control-label">Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="form.data.name"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('name')"
                  v-text="form.errors.get('name')"
                ></span>
              </div>

              <div class="form-group">
                <input type="checkbox" v-model="form.data.isSprayZone" />
                <label class="control-label">Is Spray Zone</label>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('contracts') }"
              >
                <label class="control-label">Contracts</label>
                <div v-for="(contract, index) in form.data.contracts">
                  <div class="input-group">
                    <span class="input-group-addon">{{ index + 1 }}</span>
                    <select
                      class="form-control"
                      v-model="form.data.contracts[index]"
                    >
                      <option></option>
                      <option v-for="c in contracts" v-bind:value="c.id">{{
                        c.attributes.name
                      }}</option>
                    </select>
                    <span class="input-group-addon"
                      ><i
                        class="fa fa-trash pointer"
                        v-on:click="form.removeContract(index)"
                        title="Remove contract"
                      ></i
                    ></span>
                  </div>
                </div>
                <button
                  class="btn btn-small"
                  v-on:click.prevent="form.addContract()"
                  title="Add contract"
                >
                  <i class="fa fa-plus"></i>
                </button>
                <span
                  class="help-block"
                  v-if="form.errors.has('contracts')"
                  v-text="form.errors.get('contracts')"
                ></span>
              </div>

              <loading-button
                :loading="form.loading"
                class="btn btn-primary"
                :disabled="form.errors.any()"
                >Save</loading-button
              >
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                cancel
              </button>
            </form>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <google-map ref="gmap"></google-map>

    <input
      type="file"
      id="shape"
      v-on:change="readShape()"
      accept=".zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
    />
  </div>
</template>

<script>
import ZonesService from '@/services/ZonesService';
import Form from '@/utils/form';
import LoadingButton from '@/components/loading-button';
import googleMap from '@/components/googleMap';
import Multiselect from 'vue-multiselect';
import loadGoogleMaps, {
  getGeocodeAddress,
  getCenter,
} from '../../utils/google-maps';

export default {
  name: 'zones',

  components: {
    LoadingButton,
    googleMap,
    Multiselect,
  },

  data() {
    return {
      showList: true,
      shapeFile: null,
      zoneAssociations: [],
      form: new Form(ZonesService, {
        name: null,
        coordinates: null,
        isSprayZone: false,
        contracts: [],
      }),
      contracts: [],
      addToZoneGroup: false,
      contractsToAdd: [],
      isSprayZone: false,
      loading: false,
    };
  },

  computed: {
    allShapesSelected() {
      return this.shapeFile.every((shape) => shape.selected);
    },
    contractsForAdding() {
      return this.$store.getters
        .forSelect('contracts')
        .filter((contract) => contract.id !== 'all');
    },
  },

  methods: {
    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },

    getShape() {
      document.querySelector('#shape').click();
    },

    readShape() {
      let files = document.querySelector('#shape').files;
      if (!files.length) {
        return;
      }

      var that = this;
      let fileReader = new FileReader();
      fileReader.onloadend = () => {
        document.querySelector('#shape').value = null;

        ZonesService.shape({ shape: fileReader.result }).then((data) => {
          that.shapeFile = data.map((d) => {
            return {
              type: d.type,
              properties: {
                contracts: [],
                isSprayZone: false,
                ...d.properties,
              },
              geometry: {
                coordinates: that.normalizeCoordinates(d.geometry.coordinates),
              },
            };
          });

          _.forEach(that.shapeFile, (item, index) => {
            that.zoneAssociations[index] = {
              id: 'new',
              name: item.properties.Zone,
              coordinates: this.mapPoints(item.geometry.coordinates[0]),
              contractIds: [],
              isSprayZone: false,
            };
          });

          that.showList = false;
        });
      };
      fileReader.readAsDataURL(files[0]);
    },

    normalizeCoordinates(geometry) {
      console.log(typeof geometry[0]);
      if (typeof geometry[0] === 'number') {
        let geo = [];
        geo[0] = geometry;
        console.log('return geo', geo);
        return geo;
      } else {
        return geometry;
      }
    },

    mapPoints(data) {
      let points = data.map((c) => {
        return { lat: c[1], lon: c[0] };
      });

      return points;
    },

    createZones() {
      this.loading = true;
      ZonesService.createShapes({ zones: this.zoneAssociations }).then(
        () => {
          this.form.getList();
          this.showList = true;
        },
        (error) => {
          this.loading = false;
        }
      );
    },

    toggleSelectAll() {
      const allSelected = this.shapeFile.every((shape) => shape.selected);
      // Refreshing the contractsToAdd and setting them all to a wrong value before the right value is fixing a weird bug that would
      // happen when you select contracts then try to select all or select the first item, then try to select all. It would select all, but it wouldn't
      // reflect the changes in the UI. This somehow keeps the UI in check.
      this.contractsToAdd = [...this.contractsToAdd];
      this.shapeFile.forEach(
        (shape) => (shape.selected = this.allShapesSelected)
      );
      const newSelected = !allSelected;
      this.shapeFile.forEach((shape) => (shape.selected = newSelected));
    },

    UpdateSelectedShapeFiles() {
      this.shapeFile.forEach((shape, index) => {
        if (!shape.selected) {
          return;
        }
        shape.properties.contracts = [...this.contractsToAdd];
        this.zoneAssociations[index].contractIds = this.contractsToAdd.map(
          ({ id }) => id
        );
        shape.properties.isSprayZone = this.isSprayZone;
        this.zoneAssociations[index].isSprayZone = this.isSprayZone;
      });
    },

    customLabel({ name }) {
      return name;
    },
  },

  mounted() {
    this.form.getList();
    this.form.getContracts().then((data) => {
      this.contracts = data.data;
    });
  },
};
</script>

<style lang="scss">
#map {
  height: 500px;
  width: 100%;
}
#shape {
  display: none;
}

.header-checkbox {
  margin-left: 1.5rem !important;
}

.list-checkbox {
  margin-left: -1rem !important;
}

.bulk-change-container {
  border-radius: 2px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  margin-bottom: 2rem;
  padding: 1rem;

  .bulk-change-options {
    width: 450px;
  }

  .title {
    margin-top: 1rem;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #676b6e;
  }

  .bulk-label {
    margin-top: 2rem;
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #676b6e;
  }

  input {
    margin-bottom: 2rem;
  }

  .bulk-checkbox-label {
    font-family: Roboto;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #676b6e;
    position: relative;
    top: -2px;
  }

  .update-selected-entries-button {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    padding: 1rem;
    border: none;
    border-radius: 2px;
    background-color: #00aaff;
  }
}
</style>
